/* eslint-disable max-len */
import React from "react"
import BaseSvgIcon from "./Base"

const GeoArrow = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 13 13" {...props}>
      <g>
        <polygon points="0.5,6.100000381469727 10.5,0.5 5.90000057220459,12.500000953674316 5.5,6.5 " />
      </g>
    </BaseSvgIcon>
  )
}

export default GeoArrow
